<template>
  <div id="success">
    <div class="success"></div>
    <h5>申请完成！</h5>
    <span>您已正式成为我们的
      <apply-name tag="em" />
    </span>
    <div class="btn-main btn-home">
      <router-link :to="{path:'/'}">返回首页</router-link>
    </div>
  </div>
</template>

<script>
  import ApplyName from '@/components/member/ApplyName.vue'
  export default {
    components: {
      ApplyName
    },
    data() {
       return {}
    },
    created() {
       
    },
    methods: {
       
    }
  };

</script>

<style lang="less" scoped>
  

  #success {
    height: 100%;
    background: #fff;
  }

  .success {
    width: 100%;
    height: 437/@rem-size;
    background: url('../../assets/images/success.png');
    background-size: 100% 100%;
  }

  h5 {
    font-size: 36/@rem-size;
    color: #333;
    margin-top: 24/@rem-size;
    font-weight: normal;
    text-align: center;
  }

  span {
    display: block;
    font-size: 28/@rem-size;
    text-align: center;
    margin-top: 24/@rem-size;
    color: #999;

    em {
      color: #333;
      font-style: normal;
    }
  }

  .btn-home {
    width: 360/@rem-size;
    height: 80/@rem-size;
    text-align: center;
    line-height: 80/@rem-size;
    font-size: 36/@rem-size;
    margin: 0 auto;
    margin-top: 120/@rem-size;
    border-radius: 8/@rem-size;

    a {
      color: #fff;
    }
  }

</style>
